"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var animated_1 = __importDefault(require("react-select/animated"));
var animatedComponents = (0, animated_1.default)();
function CustomSelect(_a) {
    var options = _a.options, placeholder = _a.placeholder, getOptionLabel = _a.getOptionLabel, getOptionValue = _a.getOptionValue, isOptionDisabled = _a.isOptionDisabled, value = _a.value, onChange = _a.onChange, isDisabled = _a.isDisabled, isClearable = _a.isClearable, isLoading = _a.isLoading, isSearchable = _a.isSearchable, isMulti = _a.isMulti, className = _a.className, hasError = _a.hasError, name = _a.name, dataCy = _a.dataCy;
    var getBorderColor = function (state) { return (state.isFocused ? '#5a0077' : '#d8dee2'); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_select_1.default, { closeMenuOnSelect: !isMulti, isMulti: isMulti, components: animatedComponents, classNamePrefix: "select", isDisabled: isDisabled, isOptionDisabled: isOptionDisabled, isClearable: isClearable, isLoading: isLoading, isSearchable: isSearchable, options: options, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, value: value, onChange: onChange, placeholder: placeholder && (react_1.default.createElement("span", { style: {
                    fontWeight: 500,
                    color: hasError ? '#ff0000' : 'unset',
                } }, placeholder)), theme: function (theme) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary: hasError ? '#ff0000' : '#5a0077', primary50: '#ecdcf9', primary25: '#f2e9f9' }) })); }, styles: {
                control: function (baseStyles, state) { return (__assign(__assign({}, baseStyles), { borderColor: hasError ? '#ff0000 !important' : getBorderColor(state), boxShadow: hasError ? 'none !important' : baseStyles.boxShadow, borderRadius: 0 })); },
            }, className: className, name: name, "data-cy": dataCy })));
}
exports.default = CustomSelect;
